import type { ReactNode } from 'react';

export interface ReportField {
  label: string;
  value: string | number | boolean | null | undefined;
  /** Override display value (e.g. "Active" instead of true) */
  display?: string;
  /** Span two columns */
  wide?: boolean;
}

interface ReportSectionProps {
  title:    string;
  fields:   ReportField[];
  /** Number of label/value column pairs (default 2) */
  columns?: 1 | 2;
}

function display(f: ReportField): string {
  if (f.display !== undefined) return f.display;
  if (f.value === null || f.value === undefined || f.value === '') return '—';
  if (typeof f.value === 'boolean') return f.value ? 'Yes' : 'No';
  return String(f.value);
}

export const ReportSection = ({
  title,
  fields,
  columns = 2,
}: ReportSectionProps): ReactNode => (
  <div style={{ marginBottom: '16px' }}>
    {/* Section heading */}
    <div style={{
      fontSize: '9px',
      fontWeight: 700,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: '#1e3a5f',
      borderBottom: '1px solid #1e3a5f',
      paddingBottom: '3px',
      marginBottom: '6px',
    }}>
      {title}
    </div>

    {/* Fields grid */}
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns * 2}, 1fr)`,
      gap: '2px 8px',
    }}>
      {fields.map((f, i) => (
        <div
          key={i}
          style={{
            display: 'contents',
            gridColumn: f.wide ? `span ${columns * 2}` : undefined,
          }}
        >
          <div style={{
            gridColumn: f.wide ? `1 / span ${columns}` : undefined,
            fontSize: '9px',
            color: '#6b7280',
            paddingTop: '3px',
            paddingBottom: '3px',
            borderBottom: '1px solid #f3f4f6',
            whiteSpace: 'nowrap',
          }}>
            {f.label}
          </div>
          <div style={{
            gridColumn: f.wide ? `${columns + 1} / span ${columns}` : undefined,
            fontSize: '10px',
            color: '#111827',
            fontWeight: 500,
            paddingTop: '3px',
            paddingBottom: '3px',
            borderBottom: '1px solid #f3f4f6',
          }}>
            {display(f)}
          </div>
        </div>
      ))}
    </div>
  </div>
);
